<template>
<div id="main-page">

    <main>
      <!-- MainPage现在只作为FortuneForm的容器，提交后通过路由跳转 -->
      <FortuneForm @submit="handleSubmit" @api-error="handleApiError" />
    </main>

</div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import FortuneForm from './FortuneForm.vue'

const { locale } = useI18n()
const router = useRouter()

const changeLanguage = (lang) => {
  locale.value = lang
  // 保存语言选择到localStorage
  localStorage.setItem('userLocale', lang)
}

const handleSubmit = (apiResponse) => {
  console.log('=== MainPage: Form submitted ===')
  console.log('API response:', apiResponse)
  
  if (apiResponse.formData && apiResponse.fortuneData) {
    console.log('Valid API response format detected')
    
    // 将数据保存到localStorage以便刷新后恢复
    localStorage.setItem('fortuneFormData', JSON.stringify(apiResponse.formData))
    localStorage.setItem('fortuneData', JSON.stringify(apiResponse.fortuneData))
    console.log('Data saved to localStorage')
    
    // 编码数据为URL参数
    const encodedFormData = encodeURIComponent(JSON.stringify(apiResponse.formData))
    const encodedFortuneData = encodeURIComponent(JSON.stringify(apiResponse.fortuneData))
    console.log('Data encoded for URL parameters')
    
    // 跳转到结果页面
    console.log('Navigating to /result route...')
    router.push({
      path: '/result',
      query: {
        formData: encodedFormData,
        fortuneData: encodedFortuneData
      }
    }).then(() => {
      console.log('Navigation successful')
    }).catch((error) => {
      console.error('Navigation failed:', error)
      alert('页面跳转失败，请检查控制台错误信息')
    })
  } else {
    console.error('Invalid API response format:', apiResponse)
    alert('服务器返回数据格式错误，请稍后重试')
  }
}

const handleApiError = (error) => {
  console.error('API error:', error)
  alert(`API调用失败: ${error.error || '未知错误'}`)
}
</script>

<style scoped>
#main-page {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

header h1 {
  color: #2c3e50;
  font-size: 1.8rem;
  margin: 0;
}


main {
  flex: 1;
}

footer {
  margin-top: 40px;
  padding-top: 15px;
  text-align: center;
  color: #7f8c8d;
  font-size: 0.9rem;
  border-top: 1px solid #eaeaea;
}

/* 移动端适配 */
@media (max-width: 768px) {
  #main-page {
    padding: 15px;
  }
  
  header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  header h1 {
    font-size: 1.5rem;
  }
  
}

@media (max-width: 480px) {
  #main-page {
    padding: 10px;
  }
  
  header h1 {
    font-size: 1.3rem;
  }
}
</style>